import React, { Suspense, lazy } from "react";
import Logo from "../../assets/img/teachlogo.svg";
import ContentLogo from "../../assets/img/contentSidebarLogo.svg";
import Icon from "@material-ui/core/Icon";
import AssessmentLogo from "../../assets/img/assessSidebarLogo.svg";
import ContentBlueLogo from "../../assets/img/contentSidebarBlueLogo.svg";
import AssessmentBlueLogo from "../../assets/img/assessSidebarBlueLogo.svg";
import Badge from "@material-ui/core/Badge";
import NotificationLogo from "../../assets/img/notification.svg";
import StudentsLogo from "../../assets/img/StudentsModule.svg";
import StudentsBlueLogo from "../../assets/img/StudentsModuleBlue.svg";
import SchedulerBlue from "../../assets/img/schedulerImages/calendarBlue.svg";
import SchedulerBlack from "../../assets/img/schedulerImages/calendarBlack.svg";
import Drawer from "@material-ui/core/Drawer";
import Avatar from "react-avatar";
import "./dashboard.scss";
// import Help from "../help/help";
import Notification from "../Notification/Notification";
import ClassLogo from "../../assets/img/classesIcon.svg";
import Class from "../class-component/class-component";
// import MyProfile from "../DigitalMe/MyProfile/MyProfile";
import { Switch, Route, NavLink, Redirect } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import Dropzone from "react-dropzone";
import closeLogo from "../../assets/img/closeIcon.svg";
import AppBar from "@material-ui/core/AppBar";
import PhotoUploadIcon from "../../assets/img/photouploadicon.svg";
import {
  getUserId,
  getKneuraId,
  removeClassInfo,
  getInstituteId,
  setClassInfo,
  setClassRequestInfo,
  getClassInfo,
  getClassRequestInfo,
  getInstituteKneuraId,
  getToken,
  setInstituteKneuraId,
  setInstituteId,
} from "../../utils/authentication-access";
import {
  STUDENT,
  LOGOUT,
  CLASSES,
  MULTILINGUAL,
  FORGOT_PASSWORD,
} from "../../utils/url-builder";
// import AssignmentsDashboard from "../Assignment/containers/AssignmentMainDashboard/AssignmentMainDashboard";
import { deleteAll } from "../../utils/authentication-access";
import Snackbar from "@material-ui/core/Snackbar";
import ClassList from "../class-component/class-list";
import ClassRequestList from "../class-component/class-request-list";
import BaseService from "../../store/services/base.service";
import studentsService from "../../store/services/students.service";
import { connect } from "react-redux";
import { ShakeRotate } from "reshake";
import { Mixpanel } from "../../utils/mixpanel";
import { withTranslation } from "react-i18next";
import Link from "@material-ui/core/Link";
import passwordStrength from "pwd-strength";
// import Students from "../Students/Students";
import CircularProgress from "@material-ui/core/CircularProgress";
import _ from "lodash";
import { WEBSITE_URL } from "../../config";
import {
  connectToAssessmentSocket,
  disconnectAssessmentSocket,
} from "../../store/services/assessmentSocket.service";
import ClassFeedWebView from "../Students/ClassFeedWebView";
import { KnowledgeReport } from "../Assignment/components/knowledgeReport/knowledgeReport";
import Scheduler from "../Scheduler/Scheduler";
import MyContent from '../class-component/MyContent';
import MyContentBlueIcon from "../../assets/img/myContentBlueIcon.svg";
import MyContentGreyIcon from "../../assets/img/myContentGreyIcon.svg";
import ClassRequest from "../class-request/ClassRequest"
const MyProfile = lazy(() => import("../DigitalMe/MyProfile/MyProfile"));
const AssignmentsDashboard = lazy(() =>
  import(
    "../Assignment/containers/AssignmentMainDashboard/AssignmentMainDashboard"
  ),
  );
const Help = lazy(() => import("../help/help"));
const Students = lazy(() => import("../Students/Students"));

class DashBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classdata: [],
      classRequestsData: [],
      isClassSelected: false,
      sidebar: false,
      firstName: "",
      lastName: "",
      emailAddress: "",
      settingsopen: false,
      profileImageUrl: null,
      errmsg: " ",
      openerrmsg: false,
      anchorEl: null,
      classname: "No Class Found",
      classid: "",
      contentDisplay: "WhiteBoard",
      documentDialogOpen: false,
      file: null,
      openNotification: false,
      notificationinfo: false,
      changePasswordDialog: false,
      password: "",
      confirmpassword: "",
      currentpassword: "",
      sidebarIcons: {
        lessons: false,
        tests: false,
        students: false,
        scheduler: false,
myContent:true,
      },
    };
  }

  componentDidMount() {
    let asyncHandler = async () => {
      this.changeUserLanguage();

      /** this will get student profile, including the institute ids */
      await this.getStudentInfo();
      
      /** 
       * get student info before fetching class is necessary, 
       * because class data is fetch based on institute 
       * Note: initially, student might not have institute assigned when enroled using class link
       */
      Promise.all([
        this.getAllClasses(),
        this.getAllClassRequests(),
      ]).then(() => {
        this.defaultClass()
        this.redirectTo()
      })
      
      this.sideBarActiveIconsHandler();
    }
    asyncHandler()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.sideBarActiveIconsHandler();
    }
    this.redirectTo()
  }

  classSelectedHandler = () => {
    this.setState({isClassSelected: true})
  }

  classRequestSelectedHandler = () => {
    this.setState({isClassSelected: false})
  }

  defaultClass = () => {
    if(this.state.classdata.length > 0) {
      this.classSelectedHandler()
    } else {
      this.classRequestSelectedHandler()
    }
  }

  redirectTo = () => {
    if (this.props.location.pathname === '/dashboard') {   
      this.props.history.push("/dashboard/content") 
    }
  }

  changeUserLanguage = async () => {
    // const url = MULTILINGUAL.getLanguage();
    // let res = await new BaseService().makeGetRequestGeneric(url, {
    //   access_token: getToken(),
    //   "Content-Type": "application/json",
    //   userKneuraId: getKneuraId(),
    // });
    // if (res.data.preferredLanguage) {
    //   this.props.i18n.changeLanguage(res.data.preferredLanguage);
    // } else {
    //   this.props.i18n.changeLanguage("en");
    // }
    this.props.i18n.changeLanguage("en");
  };

  getStudentInfo = async () => {
    const url = STUDENT.getStudentInfo();
    let res = await new BaseService().makeGetRequestGeneric(url);
    this.setState({ firstName: res.data.first_name });
    this.setState({ lastName: res.data.last_name });
    this.setState({ profileImageUrl: res.data.user_photo });
    this.setState({ emailAddress: res.data.email });
    localStorage.setItem("user_profile_url", res.data.user_photo);
    setInstituteKneuraId(res.data.instituteKneuraId)
    setInstituteId(res.data.instituteId)
  };

  openSidebar = () => {
    this.setState({ sidebar: true });
    Mixpanel.track("My Classes Clicked");
    // this.getAllClasses();
  };

  openNotifications = () => {
    this.setState({ openNotification: true, notificationinfo: false });
    Mixpanel.track("Notification Clicked");
  };

  closeNotification = () => {
    this.setState({ openNotification: false });
  };

  updateNotification = () => {
    this.setState({ notificationinfo: true });
  };

  closeSidebar = () => {
    this.setState({ sidebar: false });
  };

  homeClick = () => {
    this.props.history.push("/dashboard");
  };

  assessmentClick = () => {
    this.props.history.push("/dashboard/assessments");
  };

  openSettings = (event) => {
    this.setState({
      settingsopen: !this.state.settingsopen,
      anchorEl: event.currentTarget,
    });
    document.addEventListener("click", this.closePoppover);
  };

  closePoppover = () => {
    this.setState({ settingsopen: false });
    document.removeEventListener("click", this.closePoppover);
  };

  openHelp = () => {
    this.props.history.push("/dashboard/help");
  };

  onPicDrop = (imagefile) => {
    this.previewPic(imagefile[0]);
  };

  previewPic = (file) => {
    let reader = new FileReader();
    reader.onloadend = () => {
      this.setState(
        {
          file: file,
          profileImageUrl: reader.result,
        },
        () => {
          this.updateClick();
        },
      );
    };
    if (file && file.type.match("image.*")) {
      reader.readAsDataURL(file);
    }
  };

  onPicSelect(event) {
    this.previewPic(event.target.files[0]);
  }

  onRemovePicClick = () => {
    const self = this;
    // self.setState({ profileImageUrl: "" });
    this.setState({ profileImageUrl: "", file: null }, () => {
      this.updateClick();
    });
  };

  openUserProfileDialog = () => {
    this.setState({ userProfileDialog: true });
  };

  closeUserProfileDialog = () => {
    this.setState({ userProfileDialog: false });
  };

  onFirstNameEnter(event) {
    this.setState({
      firstName: event.target.value,
      errorFirstNameText: "",
      errorFirstNamestatus: false,
    });
  }

  onLastNameEnter(event) {
    this.setState({
      lastName: event.target.value,
      errorLastNameText: "",
      errorLastNamestatus: false,
    });
  }

  onContactNumberEnter(event) {
    this.setState({
      contactNumber: event.target.value,
      errorContactText: "",
      errorContactstatus: false,
    });
  }

  gotoclass = (class_info) => {
    this.setState({ classname: class_info.name, classId: class_info.classId });
    setClassInfo(class_info);
    this.setState({ sidebar: false });
    this.classSelectedHandler();
    this.props.history.push("/dashboard");
  };

  gotoclassrequest = (class_request_info) => {
    this.setState({ classname: class_request_info.class.name, classId: class_request_info.classId });
    setClassRequestInfo(class_request_info);
    this.setState({ sidebar: false });
    this.classRequestSelectedHandler()
    this.props.history.push("/dashboard");
  };



  updateClick = async () => {
    if (this.state.firstName === "") {
      this.setState({ errorfirstNamestatus: true });
      this.setState({ errorfirstNameText: "Please enter FirstName Name" });
    } else if (!this.state.firstName.charAt(0).match(/^[a-zA-Z0-9]+$/)) {
      this.setState({
        errorFirstNamestatus: true,
        errorFirstNameText: "First Character must be alphabet",
      });
    } else {
      const url = STUDENT.updateStudentInfo();
      const formData = new FormData();
      formData.append("file", this.state.file);
      formData.append("firstName", this.state.firstName);
      formData.append("lastName", this.state.lastName);
      formData.append("phone", this.state.contactNumber);
      formData.append("instituteKneuraId", getInstituteKneuraId());
      formData.append("kneuraId", getKneuraId());
      await new BaseService().makePostRequestGeneric(url, formData);
      this.setState({
        errmsg: "Profile Updated Successfully",
        openerrmsg: true,
        userProfileDialog: false,
      });
    }
  };

  getAllClasses = async () => {
    const url = STUDENT.getStudentClass();
    let res = await new BaseService().makeGetRequestGeneric(url, {
      access_token: getToken(),
      "Content-Type": "application/json",
      role: "learner",
      user_kneura_id: getKneuraId(),
      institute_kneura_id: getInstituteKneuraId(),
    });
    this.setState({ classdata: res.data });
    localStorage.setItem("classes", JSON.stringify(res.data));
    if (getClassInfo()) {
      this.setState({ classid: getClassInfo().kneuraId });
      this.setState({ classname: getClassInfo().name });
    } else if (res.data.length > 0) {
      setClassInfo(res.data[0]);
      this.setState({ classid: res.data[0].classId });
      this.setState({ classname: res.data[0].name });
    }
  };

  getAllClassRequests = async () => {
    let {classRequests} = await studentsService.getClassRequests()
    this.setState({classRequestsData: [...classRequests]})
    localStorage.setItem("classRequestsData", JSON.stringify(classRequests));
    if (getClassRequestInfo()) {
      this.setState({ classidOfClassRequest: getClassRequestInfo().classId });
      this.setState({ classnameOfClassRequest: getClassRequestInfo().class.name });
    } else if (classRequests.length > 0) {
      setClassRequestInfo(classRequests[0]);
      this.setState({ classidOfClassRequest: classRequests[0].classId });
      this.setState({ classnameOfClassRequest: classRequests[0].class.name });
    }
  }

  logoutClick = async () => {
    const url = LOGOUT.logout();
    await new BaseService().makeGetRequestGeneric(url);
    deleteAll();
    // this.props.history.push("/login");
    Mixpanel.track("Successful Logout");
    window.location.replace(WEBSITE_URL);
  };

  openType = (type) => {
    this.setState({ contentDisplay: type });
  };

  openChangePassword = () => {
    this.setState({ userProfileDialog: false, changePasswordDialog: true });
  };

  closeChangePasswordDialog = () => {
    this.setState({
      changePasswordDialog: false,
      password: "",
      confirmpassword: "",
      currentpassword: "",
    });
  };

  onOldPasswordEnter(event) {
    this.setState({ currentpassword: event.target.value });
    this.setState({ oldpassworderrorstatus: false, oldpassworderrorText: "" });
  }

  onPasswordEnter(event) {
    this.setState({ password: event.target.value });
    this.setState({ passworderrorstatus: false, passworderrorText: "" });
  }

  onConfirmPasswordEnter(event) {
    this.setState({ confirmpassword: event.target.value });
    this.setState({
      confirmpassworderrorstatus: false,
      confirmpassworderrorText: "",
    });
  }

  resetPasswordClick = async () => {
    if (this.state.currentpassword === "") {
      this.setState({ oldpassworderrorstatus: true });
      this.setState({ oldpassworderrorText: "Enter Current Password" });
    } else if (this.state.password === "") {
      this.setState({ passworderrorstatus: true });
      this.setState({ passworderrorText: "Enter Password" });
    } else if (this.state.password.length < 8) {
      this.setState({ passworderrorstatus: true });
      this.setState({ passworderrorText: "Password too short." });
    } else if (
      !passwordStrength(this.state.password, {
        minUpperChars: 1,
        minLowerChars: 1,
        minSpecialChars: 1,
      }).success
    ) {
      let errorMsg = passwordStrength(this.state.password, {
        minUpperChars: 1,
        minLowerChars: 1,
        minSpecialChars: 1,
      }).message;
      this.setState({ passworderrorstatus: true });
      this.setState({ passworderrorText: errorMsg });
    } else if (!passwordStrength(this.state.password).success) {
      this.setState({ passworderrorstatus: true });
      this.setState({
        passworderrorText: "Password is not safe. Please try another password",
      });
    } else if (this.state.confirmpassword === "") {
      this.setState({ confirmpassworderrorstatus: true });
      this.setState({ confirmpassworderrorText: "Re-Enter Password" });
    } else if (this.state.confirmpassword !== this.state.password) {
      this.setState({ confirmpassworderrorstatus: true });
      this.setState({ confirmpassworderrorText: "Password MisMatch" });
    } else {
      const url = FORGOT_PASSWORD.changePassword();
      await new BaseService().makePostRequestGeneric(url, {
        email: this.state.emailAddress.toLowerCase(),
        currentPassword: this.state.currentpassword,
        newPassword: this.state.password,
      });
      this.setState({
        changePasswordDialog: false,
        errmsg: "Password Changed Successfully",
      });
      this.setState({ openerrmsg: true });
      Mixpanel.track("Password Changed Successfully");
    }
  };

  sideBarActiveIconsHandler = () => {
    let sidebarIconsState = _.cloneDeep(this.state.sidebarIcons);

    Object.keys(sidebarIconsState).forEach((key) => {
      sidebarIconsState[key] = false;
    });
    switch (this.props.location.pathname) {
      case "/dashboard/content":
        sidebarIconsState.lessons = true;
        break;
      case "/dashboard/assessments":
        sidebarIconsState.tests = true;
        break;
      case "/dashboard/students":
        sidebarIconsState.students = true;
        break;
      case "/dashboard/scheduler":
        sidebarIconsState.scheduler = true;
        break;
      case "/dashboard/myContent":
        sidebarIconsState.myContent = true;
        break;
      default:
        break;
    }
    this.setState({ sidebarIcons: _.cloneDeep(sidebarIconsState) });
  };

  showErrMessage = (msg) => {
    this.setState({
      errmsg: msg,
      openerrmsg: true,
    });
  };

  renderSideBarTop = () => {
    const { t, i18n } = this.props;
    return (
      <>
        <NavLink activeClassName="dash-active" to="/dashboard/content">
          <div
            onClick={this.sideBarActiveIconsHandler}
            className="SidebarIcon"
          >
            <img
              className="contentlogo"
              src={
                this.state.sidebarIcons.lessons
                  ? ContentBlueLogo
                  : ContentLogo
              }
              alt="Logo"
            />
            <p className={this.state.sidebarIcons.lessons ? "ColorBlue" : ""}>
              {t("Lessons")}
            </p>
          </div>
        </NavLink>
        <NavLink activeClassName="dash-active" to="/dashboard/myContent">
          <div
            onClick={this.sideBarActiveIconsHandler}
            className="SidebarIcon"
          >
            <img
              className="contentlogo"
              src={
                this.state.sidebarIcons.myContent
                  ? MyContentBlueIcon
                  : MyContentGreyIcon
              }
              alt="Logo"
            />
            <p className={this.state.sidebarIcons.myContent ? "ColorBlue" : ""}>
              {t("Content")}
            </p>
          </div>
        </NavLink>
        <NavLink activeClassName="dash-active" to="/dashboard/assessments">
          <div
            onClick={this.sideBarActiveIconsHandler}
            className="SidebarIcon"
          >
            <img
              className="contentlogo"
              src={
                this.state.sidebarIcons.tests
                  ? AssessmentBlueLogo
                  : AssessmentLogo
              }
              alt="Logo"
            />
            <p className={this.state.sidebarIcons.tests ? "ColorBlue" : ""}>
              {t("Tests")}
            </p>
          </div>
        </NavLink>
        <NavLink to="/dashboard/students">
        <div
          onClick={this.sideBarActiveIconsHandler}
          className="SidebarIcon"
        >
          <img
            className="contentlogo"
            src={
              this.state.sidebarIcons.students
                ? StudentsBlueLogo
                : StudentsLogo
            }
            alt="Logo"
          />
            <p className={this.state.sidebarIcons.students ? "ColorBlue" : ""}>
              {t("Students")}
            </p>
          </div>
        </NavLink>
        <NavLink to="/dashboard/scheduler">
          <div onClick={this.sideBarActiveIconsHandler} className="SidebarIcon">
            <img
              className="contentlogo"
              src={
                this.state.sidebarIcons.scheduler
                  ? SchedulerBlue
                  : SchedulerBlack
              }
              style={{ width: "25px" }}
              alt="Logo"
            />
            <p className={this.state.sidebarIcons.scheduler ? "ColorBlue" : ""}>
              {t("Calendar")}
            </p>
          </div>
        </NavLink>
      </>
    )
  }

  renderSideBar = () => {
    const { t, i18n } = this.props;
    return (<div className="sidebar-grid">
      <div className="sidebar-grid-items">
        <NavLink to="/dashboard">
          <img className="teachlogo" src={Logo} alt="Logo" />
        </NavLink>
        {this.state.isClassSelected && this.renderSideBarTop()}
      </div>
      <div />

      <div className="sidebar-grid-items">
        <div className="SidebarIcon" onClick={this.openSidebar}>
          <img className="contentlogo" src={ClassLogo} alt="Logo" />
          <p>{t("Classes")}</p>
        </div>
        <div className="hover">
          <ShakeRotate
            active={this.state.notificationinfo}
            dur={750}
            fixed={true}
          >
            <Badge
              overlap="circle"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              invisible={!this.state.notificationinfo}
              badgeContent={<div className="notification-dot" />}
            >
              <Avatar
                size="40"
                alt="Notification"
                src={NotificationLogo}
                onClick={this.openNotifications}
              />
            </Badge>
            {/* <img
                className="notificationLogo"
                src={NotificationLogo}
                alt="Notification"
              /> */}
          </ShakeRotate>
        </div>
        <NavLink activeClassName="dash-active" to="/dashboard/my-profile">
          <div
            className="hover"
            style={{
              display: "flex",
              width: "75px",
              height: "75px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Avatar
              name={this.state.firstName}
              // onClick={this.openSettings}
              round={true}
              size="40"
              src={this.state.profileImageUrl}
            />
          </div>
        </NavLink>
      </div>
    </div>
    )
  }
  render() {
    const { t, i18n } = this.props;
    const gridClass =
      this.state.contentDisplay === "File" ? "content-grid-no" : "content-grid";
    const showSideBar = this.props.showSideBar;
    const dashboardClass = showSideBar ? "dashboard-grid" : "dashboard-no-grid";
    return (
      <div className={dashboardClass}>
        {showSideBar ? this.renderSideBar() : <></>}

        <Suspense
          fallback={
            <div className="loadingGrid">
              <CircularProgress size={50} thickness={2} />
              <div className="loadingText">Loading</div>
            </div>
          }
        >
          <Switch>
            <Route
              path="/dashboard/classFeed-webview"
              render={(props) => <ClassFeedWebView {...props} />}
            />
            <Route
              path={"/dashboard/assessments"}
              render={(props) => (
                <AssignmentsDashboard
                  history={this.props.history}
                  classname={this.state.classname}
                  openClassSideBar={this.openSidebar}
                />
              )}
            />
            <Route
              path={"/dashboard/help"}
              render={(props) => <Help title="Help" />}
            />
            <Route
              path={"/dashboard/content"}
              render={(props) => (
                <Class
                  {...props}
                  history={this.props.history}
                  classname={this.state.classname}
                  classData={this.state.classdata}
                  classRequestsData={this.state.classRequestsData}
                  title="My Content"
                  isClassSelected={this.state.isClassSelected}
                  openClassSideBar={this.openSidebar}
                />
              )}
            />
            <Route
              path={"/dashboard/myContent"}
              render={(props) => (
                <MyContent
                  history={this.props.history}
                  classname={this.state.classname}
                  title="My Content"
                  openClassSideBar={this.openSidebar}
                />
              )}
            />
            <Route
              path={"/dashboard/my-profile"}
              exact
              render={(props) => (
                <MyProfile
                  title="My Profile"
                  openUserProfile={this.openUserProfileDialog}
                />
              )}
            />
            <Route
              path={"/dashboard/my-profile/knowledge-report"}
              exact
              render={(props) => <KnowledgeReport />}
            />
            <Route
              path={"/dashboard/students"}
              render={(props) => (
                <Students
                  {...props}
                  openClassesDrawer={this.openSidebar}
                  classname={this.state.classname}
                />
              )}
            />
            <Route
              path={"/dashboard/scheduler"}
              render={(props) => (
                <Scheduler
                  {...props}
                  openClassesDrawer={this.openSidebar}
                  classname={this.state.classname}
                />
              )}
            />

            {/* <Redirect from="/dashboard" to={this.state.classdata.length ? "/dashboard/content" : "/dashboard/class-requests"} /> */}
          </Switch>
        </Suspense>

        {/* <Popover
          open={this.state.settingsopen}
          className="popoveroverlay"
          onClose={this.closePoppover}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ vertical: "center", horizontal: "right" }}
          transformOrigin={{ vertical: "center", horizontal: "left" }}
        >
          <div className="card setting-popover-user">
            <div className="padding-2">
              <Avatar
                name={this.state.firstName}
                round={true}
                size="50"
                src={this.state.profileImageUrl}
              />
            </div>
            <div className="padding-2">
              {this.state.firstName} {this.state.lastName}
            </div>
            <div className="text-secondary small padding-2">
              {this.state.emailAddress}
            </div>
            <div className="padding-2"></div>
            <div
              className="padding-2 drop-item profile-background"
              onClick={this.openUserProfileDialog}
            >
              Manage Profile
            </div>
            <div
              className="padding-2 drop-item profile-background"
              onClick={this.openHelp}
            >
              Help
            </div>
            <div
              className="padding-2 drop-item profile-background"
              onClick={this.logoutClick}
            >
              Logout
            </div>
          </div>
        </Popover> */}

        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          className="overlay"
          open={this.state.userProfileDialog}
          onClose={this.closeUserProfileDialog}
        >
          <div
            className="dialog-modal-header"
            style={{ background: "rgba(0, 116, 228, 0.25)" }}
          >
            <div />
            <div className="text-center">
              <img
                className="close-icon hover"
                onClick={this.closeUserProfileDialog}
                src={closeLogo}
                alt="Close"
              />
            </div>
          </div>
          <div className="modal-card">
            <div className="modal-title">{t("Profile")}</div>
            <div className="modal-subtitle">
              {t("Customize your personal profile")}
            </div>

            <div className="submenu-profile-img mb-2 mt-2">
              <Dropzone
                multiple={false}
                accept="image/*"
                onDrop={this.onPicDrop}
              >
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()} className="text-center">
                    <input {...getInputProps()} />
                    <img
                      alt="Upload profile pic"
                      style={
                        this.state.profileImageUrl
                          ? { height: 100, width: 100, borderRadius: 50 }
                          : {}
                      }
                      src={
                        this.state.profileImageUrl
                          ? this.state.profileImageUrl
                          : PhotoUploadIcon
                      }
                    />
                  </div>
                )}
              </Dropzone>

              <div className="div-center">
                <label htmlFor="file-upload" className="uploadpic-button">
                  {t("Change")}
                </label>
                <input
                  id="file-upload"
                  className="file-type"
                  type="file"
                  accept="image/*"
                  onChange={this.onPicSelect.bind(this)}
                />
                {t("or")}
                <button
                  className="remove-button"
                  disabled={!this.state.profileImageUrl}
                  onClick={this.onRemovePicClick}
                >
                  {" "}
                  {t("remove")}{" "}
                </button>
              </div>
            </div>

            <div className="col-md-9 padding-2 edit-grid mt-2">
              <TextField
                id="FirstName"
                variant="outlined"
                label={t("First Name")}
                value={this.state.firstName}
                onFocus={() => {
                  this.setState({ infoopen: false });
                }}
                onChange={this.onFirstNameEnter.bind(this)}
                helperText={t(this.state.errorFirstNameText)}
                error={this.state.errorFirstNamestatus}
                disabled
              />

              <TextField
                id="LastName"
                variant="outlined"
                label={t("Last Name(optional)")}
                value={this.state.lastName}
                onFocus={() => {
                  this.setState({ infoopen: false });
                }}
                onChange={this.onLastNameEnter.bind(this)}
                helperText={t(this.state.errorLastNameText)}
                error={this.state.errorLastNamestatus}
                disabled
              />
            </div>
            <div>
              <Link
                component="button"
                style={{ fontSize: 16 }}
                onClick={this.openChangePassword}
              >
                {t("Change account password")}
              </Link>
            </div>
          </div>
        </Dialog>

        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          className="overlay"
          open={this.state.changePasswordDialog}
          onClose={this.closeChangePasswordDialog}
        >
          <div
            className="dialog-modal-header"
            style={{ background: "rgba(0, 116, 228, 0.25)" }}
          >
            <div />
            <div className="text-center">
              <img
                className="close-icon hover"
                onClick={this.closeChangePasswordDialog}
                src={closeLogo}
                alt="Close"
              />
            </div>
          </div>
          <div className="modal-card">
            <div className="modal-title">{t("Change Password")}</div>
            <div className="col-md-9 padding-2 edit-grid">
              <TextField
                type="password"
                label="Current password"
                className="passwordbox"
                variant="outlined"
                margin="normal"
                style={{ marginTop: "-5px" }}
                value={this.state.currentpassword}
                helperText={this.state.oldpassworderrorText}
                error={this.state.oldpassworderrorstatus}
                onChange={this.onOldPasswordEnter.bind(this)}
              />
              <TextField
                type="password"
                label="New password"
                className="passwordbox"
                variant="outlined"
                margin="normal"
                style={{ marginTop: "-5px" }}
                value={this.state.password}
                helperText={this.state.passworderrorText}
                error={this.state.passworderrorstatus}
                onChange={this.onPasswordEnter.bind(this)}
              />
              <TextField
                type="password"
                label="Re-enter password"
                className="passwordbox"
                variant="outlined"
                margin="normal"
                style={{ marginTop: "-5px" }}
                value={this.state.confirmpassword}
                helperText={this.state.confirmpassworderrorText}
                error={this.state.confirmpassworderrorstatus}
                onChange={this.onConfirmPasswordEnter.bind(this)}
              />
            </div>
            <div className="col-md-12">
              <DialogActions>
                <button
                  className="btn-button-blank"
                  onClick={this.closeChangePasswordDialog}
                >
                  {t("Cancel")}
                </button>
                <button
                  className="btn-button-learn"
                  onClick={this.resetPasswordClick}
                >
                  {t("Save password")}
                </button>
              </DialogActions>
            </div>
          </div>
        </Dialog>

        <Notification
          openNotification={this.state.openNotification}
          gotoclass={this.gotoclass}
          closeNotification={this.closeNotification}
          history={this.props.history}
          gotoNotification={this.updateNotification}
          showSnackBarMessage={this.showErrMessage}
        />

        <Drawer open={this.state.sidebar} onClose={this.closeSidebar}>
          <AppBar position="sticky" color="transparent" elevation={0}>
            <div className="back-button" onClick={this.closeSidebar}>
              <Icon className="backiconstyle"> arrow_back</Icon>
              <div className="back-buttontext">{t("Classes")}</div>
            </div>
          </AppBar>
          <div className="sidebarclass-grid">
            <div>
              {this.state.classdata.length > 0 ? (
                this.state.classdata.map((item) => (
                  <ClassList
                    selectedClass={this.state.classname}
                    classinfo={item}
                    gotoclass={this.gotoclass}
                    history={this.props.history}
                  />
                ))
              ) : (
                <div className="back-buttontext"> {t("No Class Found")}</div>
              )}
            </div>
            <div className="sidebar_class_request">{t("Class Requests")}</div>
            <div>
              {this.state.classRequestsData && this.state.classRequestsData.length > 0 ? (
                this.state.classRequestsData.map((item) => (
                  <ClassRequestList
                    selectedClass={this.state.classnameOfClassRequest}
                    classRequestInfo={item}
                    gotoclassrequest={this.gotoclassrequest}
                    history={this.props.history}
                  />
                ))
              ) : (
                <div className="subtitle"> {t("No Class Request Found")}</div>
              )}
            </div>
          </div>
        </Drawer>

        <Snackbar
          message={t(this.state.errmsg)}
          open={this.state.openerrmsg}
          onClose={() => this.setState({ openerrmsg: false })}
          autoHideDuration={2000}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    showSideBar: state.ui.sideBar,
  };
};
export default connect(mapStateToProps)(withTranslation()(DashBoard));
